import React from "react"
import { Link } from "react-router-dom"
import { Play, ArrowRight } from "lucide-react"

const interiorProjects = [
  {
    id: 1,
    title: "Lumière Penthouse",
    location: "New York, USA",
    type: "Residential",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80&fit=crop",
    aspect: "portrait",
  },
  {
    id: 2,
    title: "Marble & Oak Kitchen",
    location: "London, UK",
    type: "Residential",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80&fit=crop",
    aspect: "landscape",
  },
  {
    id: 3,
    title: "Obsidian Suite",
    location: "Tokyo, Japan",
    type: "Hospitality",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=900&q=80&fit=crop",
    aspect: "landscape",
  },
  {
    id: 4,
    title: "Serenity Spa",
    location: "Dubai, UAE",
    type: "Wellness",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&q=80&fit=crop",
    aspect: "portrait",
  },
]

export default function InteriorShowcase() {
  return (
    <section className="py-24 lg:py-32 bg-stone-950">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-16">
          <div>
            <span className="inline-flex items-center gap-2 font-['Space_Grotesk'] text-[10px] tracking-[0.3em] text-amber-400 uppercase mb-4">
              <span className="w-6 h-px bg-amber-400" />
              Interior Design
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl lg:text-6xl font-light text-stone-100 leading-tight">
              Interiors that<br />
              <span className="italic text-stone-400">breathe and live</span>
            </h2>
          </div>
          <p className="font-['Inter'] text-sm text-stone-400 leading-relaxed lg:max-w-sm lg:ml-auto">
            Every room is a canvas. We layer texture, tone, and light to create environments that resonate on a visceral level — spaces where you genuinely want to be.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          {interiorProjects.map((project) => (
            <div
              key={project.id}
              className={`group relative overflow-hidden cursor-pointer ${
                project.aspect === "portrait" ? "md:row-span-1 h-80 lg:h-[480px]" : "h-64 lg:h-64"
              }`}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/85 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-400">
                <span className="font-['Space_Grotesk'] text-[9px] tracking-[0.3em] text-amber-400 uppercase block mb-1">
                  {project.type}
                </span>
                <h4 className="font-['Cormorant_Garamond'] text-xl font-light text-stone-100">{project.title}</h4>
                <p className="font-['Inter'] text-xs text-stone-400">{project.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Video Section */}
        <div className="mt-3 relative overflow-hidden h-72 lg:h-[50vh] cursor-pointer group">
          <img
            src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=1800&q=80&fit=crop"
            alt="Interior Design Showreel"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-stone-950/50 flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
              <button className="w-20 h-20 border-2 border-stone-100 rounded-full flex items-center justify-center text-stone-100 hover:bg-stone-100 hover:text-stone-950 transition-all duration-300 group-hover:scale-110">
                <Play size={28} fill="currentColor" />
              </button>
              <span className="font-['Space_Grotesk'] text-xs tracking-[0.3em] text-stone-300">WATCH INTERIOR SHOWREEL</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-10 flex justify-center">
          <Link
            to="/works"
            className="inline-flex items-center gap-3 font-['Space_Grotesk'] text-[11px] tracking-[0.2em] text-stone-400 hover:text-amber-400 border border-stone-700 hover:border-amber-400 px-8 py-4 transition-all duration-300 group"
          >
            VIEW ALL INTERIORS
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  )
}
